import { Fragment, useContext, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SelectableContext from '../../../../contexts/local/selectable/SelectableContext';
import ProcessContext from '../../../../contexts/process/ProcessContext';
import StatusBarButton from '../../../layout/StatusBarButton';
import Channel from './Channel';
import Panel from './Panel';
import PlantBlockSelectable from './PlantBlockSelectable';
import Loading from '../../../ui-elements/Loading';
import UIContext from '../../../../contexts/ui/UIContext';

const PanelSelection = ({ forwardTo, photo, selectedSlots }) => {
  const { additionalProcessInformation, loadOccupancy, occupancyArray, activeProcessId, continueProcess } =
    useContext(ProcessContext);

  const { loading } = useContext(UIContext);
  const navigate = useNavigate();
  const usePhoto = photo;
  const [showContinueButton, setShowContinueButton] = useState(false);

  const load = async () => {
    await loadOccupancy(additionalProcessInformation.sourceEntity, 'panel');
  };

  useEffect(() => {
    load();
  }, []);

  const { selection,  Sidebar, isSelecting, setSelection } = useContext(SelectableContext);

  const isValidSelectedSlots = useRef(false);

  useEffect(() => {
    if (selection.length > 0 && !isSelecting) {
      setShowContinueButton(true);
    } else if (isSelecting) {
      setShowContinueButton(false);
    }
  }, [selection, isSelecting]);

  const proceedToConfirmation = async (executableSlots = null) => {
    try {
      if (executableSlots) {
        await continueProcess(activeProcessId, executableSlots);
      } else{
        await continueProcess(activeProcessId, selection);
      }
      navigate(forwardTo);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (!selectedSlots) {
      return;
    }
    const executableSlots = selectedSlots?.filter(item => item.executable === true).map(sl => sl.sourceSlot);
    isValidSelectedSlots.current = Array.isArray(executableSlots) && executableSlots?.every((value) =>
      typeof value === 'number'
      && value >= 0
      && value <= 4999999
    );

    if (isValidSelectedSlots.current) {
      setSelection(executableSlots);
      const automatedProcess = async () => {
        await proceedToConfirmation(executableSlots);
      };
      automatedProcess();
    }
  }, [selectedSlots]);



  return loading ? (
    <Loading fullScreen />
  ) : (
    <Fragment>
      {Sidebar}

      <Panel>
  {occupancyArray.map((channel) => (
    <Channel key={channel.channelNumber} channel={channel}>
      {channel.plantSlotBlocks.map((block, index) => {
        return (
          <PlantBlockSelectable
            key={`${channel.channelNumber}-${block.startPlantSlotOrdinalNumber}-${block.endPlantSlotOrdinalNumber}`}
            block={block}
            channelNr={channel.channelNumber}
            index={index}
            hideContent={!block.isOccupied}
            disabled={
              !block.isOccupied ||
              (additionalProcessInformation.endOfLife && block.isOccupied && block.harvestCount === 0)
            }
            style={{
              height:
                (block.endPlantSlotOrdinalNumber - block.startPlantSlotOrdinalNumber + 1) / ( parseInt(import.meta.env.VITE_PANELSETTINGS_TOTALPLANTSLOTSPERCHANNEL)  / 100) + '%'
            }}
            endOfLife={additionalProcessInformation?.endOfLife}
            photo={usePhoto}
            harvesting={false}
          />
        );
      })}
    </Channel>
  ))}
</Panel>
      {showContinueButton && (
        <Fragment>
          <StatusBarButton
            label='Continue'
            icon='fas fa-chevron-right'
            reversed={true}
            clickHandler={() => proceedToConfirmation()}
            statusSlot={5}
          />
        </Fragment>
      )}
    </Fragment>
  );
};

export default PanelSelection;